<template>
  <div>
    <general-progress-bars
      :items="downloadProgressData"
      prefixText="Baixando as metas importadas no sistema"
    />
    <v-alert
      dense
      dismissible
      outlined
      id="info-kpis-aderencias-bdgd"
      class="font-weight-medium mt-4"
      :color="color"
      :icon="icon"
      :type="type"
    >
      Para que o cálculo funcione corretamente, certifique-se que:
      <ul>
        <li>
          as metas estão importadas e atualizadas.
          Caso precise atualizar as metas, por favor, 
          entre em contato com a equipe de suporte do Hexa.
          <a href="javascript:void(0)" @click="downloadSpreadSheet(consultaId)" v-if="consultaId">
            Clique aqui para baixar as metas importadas no sistema.
          </a>
        </li>
        <li>
          incrementos GIS estão importados e atualizados{{ txtUltimaImportacao }}.
        </li>
      </ul>
    </v-alert>
  </div>
</template>

<script>
import KpisAderenciasBdgdService from "@/services/KpisAderenciasBdgdService";
import downloadSpreadSheet from "@/mixins/downloadSpreadSheet";
import dayjs from "dayjs";

export default {
  name: "Info",
  components: {
    GeneralProgressBars: () => import("@/components/general/GeneralProgressBars.vue"),
  },
  mixins: [
    downloadSpreadSheet
  ],
  data() {
    return {
      ultimaImportacao: null,
      consultaId: null,
    };
  },
  computed: {
    error() {
      return !(this.ultimaImportacao && this.consultaId);
    },
    color() {
      return this.error ? "red" : "blue";
    },
    icon() {
      return this.error ? "mdi-alert-rhombus" : "mdi-information";
    },
    type() {
      return this.error ? "error" : "info";
    },
    txtUltimaImportacao() {
      let txtUltimaImportacao = "";
      if (this.ultimaImportacao) {
        const formated = dayjs(this.ultimaImportacao).format(
          "DD/MM/YYYY HH:mm"
        );
        txtUltimaImportacao = ` (última importação em ${formated})`;
      }
      return txtUltimaImportacao;
    },
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      KpisAderenciasBdgdService.getInfo()
        .then((res) => {
          const { ultimaImportacao, consultaId } = res.data;

          if (ultimaImportacao) {
            this.ultimaImportacao = ultimaImportacao;
          }

          if (consultaId) {
            this.consultaId = consultaId;
          }
        })
        .catch((err) => {
          console.log("Erro: ", err);
          this.$toast.error(
            "Ocorreu um erro ao carregar as informações das importações de metas e incrementos GIS.",
            "",
            { position: "topRight" }
          );
        });
    },
  },
};
</script>

<style>
.v-alert__icon {
  align-self: center;
}
.v-alert__content {
  text-align: justify;
} 
</style>